import * as actionTypes from './actionTypes';

export const submitRSP = (payload) => ({ type: actionTypes.SUBMIT, payload });
export const submitRSPSuccess = (payload) => ({ type: actionTypes.SUBMIT_SUCCESS, payload });
export const submitRSPDataFailure = (payload) => ({ type: actionTypes.SUBMIT_FAILURE, payload });

export const confirmRSP = (payload) => ({ type: actionTypes.CONFIRM, payload });
export const confirmRSPSuccess = (payload) => ({ type: actionTypes.CONFIRM_SUCCESS, payload });
export const confirmRSPDataFailure = (payload) => ({ type: actionTypes.CONFIRM_FAILURE, payload });

export const resetRSP = () => ({ type: actionTypes.RESET });
